import { sb } from '../supabase.ts';

export async function renderPromotionPage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .prom-wrap { background: #f1f5f9; min-height: 100vh; padding: 32px; font-family: 'Inter', sans-serif; }
  .prom-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1); overflow: hidden; }
  .prom-header { padding: 24px 32px; border-bottom: 1px solid #f1f5f9; background: #fff; display: flex; justify-content: space-between; align-items: center; }
  .prom-header h2 { font-size: 24px; font-weight: 800; color: #0f172a; margin: 0; }
  .prom-header p { font-size: 14px; color: #64748b; margin-top: 4px; }
  
  .filters { padding: 24px 32px; background: #fff; border-bottom: 1px solid #f1f5f9; display: flex; gap: 16px; flex-wrap: wrap; align-items: flex-end; }
  .f-group { display: flex; flex-direction: column; gap: 6px; flex: 1; min-width: 160px; }
  .f-group label { font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.05em; }
  .f-group select, .f-group input { padding: 10px 14px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; background: #f8fafc; transition: all 0.2s; }
  .f-group select:focus, .f-group input:focus { outline: none; border-color: var(--primary); box-shadow: 0 0 0 3px rgba(0, 97, 242, 0.1); background: #fff; }
  
  .btn-load { background: var(--primary); color: #fff; border: none; padding: 10px 24px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: 0.3s; height: 42px; }
  .btn-load:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 97, 242, 0.2); }

  .search-wrap { padding: 16px 32px; background: #fff; border-bottom: 1px solid #f1f5f9; display: flex; gap: 12px; align-items: center; }
  .search-input { flex: 1; padding: 10px 16px; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; background: #f8fafc; }

  .table-container { width: 100%; overflow-x: auto; max-height: 60vh; }
  table { width: 100%; border-collapse: collapse; }
  thead th { position: sticky; top: 0; background: #f8fafc; z-index: 10; padding: 14px 16px; text-align: left; font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; border-bottom: 2px solid #f1f5f9; }
  tbody td { padding: 14px 16px; border-bottom: 1px solid #f1f5f9; font-size: 14px; vertical-align: middle; }
  
  .p-input { padding: 8px 12px; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 13px; width: 100%; transition: 0.2s; background: #fff; }
  .p-input:focus { border-color: var(--primary); outline: none; box-shadow: 0 0 0 3px rgba(0, 97, 242, 0.1); }
  
  .rank-badge { background: #f0f9ff; color: #0366d6; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 700; margin-top: 4px; display: inline-block; }
  .group-tag { font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; }

  .btn-promote { background: #10b981; color: #fff; border: none; padding: 8px 16px; border-radius: 8px; font-weight: 600; cursor: pointer; font-size: 12px; white-space: nowrap; transition: 0.2s; }
  .btn-promote:hover { background: #059669; }
  .btn-promote:disabled { opacity: 0.6; cursor: not-allowed; }

  .bulk-footer { padding: 24px 32px; background: #fff; border-top: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
  .stats-info { font-size: 14px; color: #475569; font-weight: 500; }
  .btn-bulk { background: #0f172a; color: #fff; border: none; padding: 14px 32px; border-radius: 12px; font-weight: 700; cursor: pointer; transition: 0.3s; display: flex; align-items: center; gap: 8px; }
  .btn-bulk:hover { background: #1e293b; transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1); }
  .btn-bulk:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

  .loading-state { padding: 80px; text-align: center; color: #64748b; }
  .pulse { animation: pulse 2s infinite; }
  @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
</style>

<div class="prom-wrap">
  <div class="container">
    <div class="prom-card">
      <div class="prom-header">
        <div>
          <h2>Student Promotion Tool</h2>
          <div style="display:flex; align-items:center; gap:8px; margin-top:8px;">
            <span style="font-size:14px; color:#64748b; font-weight:600;">Transition Cycle:</span>
            <select id="sessionSource" style="padding:4px 8px; border-radius:6px; border:1px solid #e2e8f0; font-size:13px; font-weight:700; color:var(--primary);">
              <option value="2024">2024</option>
              <option value="2025" selected>2025</option>
              <option value="2026">2026</option>
            </select>
            <span style="color:#94a3b8;">➔</span>
            <select id="sessionTarget" style="padding:4px 8px; border-radius:6px; border:1px solid #e2e8f0; font-size:13px; font-weight:700; color:#10b981;">
              <option value="2025">2025</option>
              <option value="2026" selected>2026</option>
              <option value="2027">2027</option>
            </select>
          </div>
        </div>
        <div id="topStatus" class="stats-info"></div>
      </div>
      
      <div class="filters">
        <div class="f-group">
          <label id="sourceClassLabel">Source Class (2025)</label>
          <select id="classFilter">
            <option value="">Loading...</option>
          </select>
        </div>
        <div class="f-group">
          <label id="sourceSectionLabel">Source Section (2025)</label>
          <select id="sectionFilter">
            <option value="">Loading...</option>
          </select>
        </div>
        <button class="btn-load" id="loadBtn">Load Batch</button>
      </div>

      <div class="search-wrap" id="searchWrap" style="display:none;">
        <input type="text" class="search-input" id="tableSearch" placeholder="Filter by Name or IID...">
        <div class="stats-info" id="matchCount"></div>
      </div>

      <div class="table-container" id="studentTable">
        <div class="loading-state">
          <div style="font-size: 48px; margin-bottom: 16px;">🎓</div>
          <p>Select class and section to begin promotion process.</p>
        </div>
      </div>

      <div class="bulk-footer" id="bulkFooter" style="display:none;">
        <div class="stats-info" id="footerStats"></div>
        <button class="btn-bulk" id="bulkUpdateBtn">
          <span>Promote Selected Students</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>
    </div>
  </div>
</div>
  `;

  const loadBtn = document.getElementById('loadBtn')!;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const sectionFilter = document.getElementById('sectionFilter') as HTMLSelectElement;
  const sessionSource = document.getElementById('sessionSource') as HTMLSelectElement;
  const sessionTarget = document.getElementById('sessionTarget') as HTMLSelectElement;
  const sourceClassLabel = document.getElementById('sourceClassLabel')!;
  const sourceSectionLabel = document.getElementById('sourceSectionLabel')!;
  const tableContainer = document.getElementById('studentTable')!;
  const bulkFooter = document.getElementById('bulkFooter')!;
  const bulkUpdateBtn = document.getElementById('bulkUpdateBtn') as HTMLButtonElement;
  const searchWrap = document.getElementById('searchWrap')!;
  const tableSearch = document.getElementById('tableSearch') as HTMLInputElement;
  const matchCount = document.getElementById('matchCount')!;
  const footerStats = document.getElementById('footerStats')!;

  let students: any[] = [];
  let ranks: Record<string, number> = {};

  sessionSource.onchange = () => {
    sourceClassLabel.textContent = `Source Class (${sessionSource.value})`;
    sourceSectionLabel.textContent = `Source Section (${sessionSource.value})`;
    loadDynamicFilters();
  };

  async function loadDynamicFilters() {
    const srcYear = sessionSource.value;
    const classCol = `class_${srcYear}`;
    const sectionCol = `section_${srcYear}`;

    classFilter.innerHTML = '<option value="">Loading...</option>';
    sectionFilter.innerHTML = '<option value="">Loading...</option>';

    try {
      // Fetch unique classes
      const { data: classesData } = await sb.from('student_database')
        .select(classCol)
        .not(classCol, 'is', null);
      
      const uniqueClasses = [...new Set(((classesData as any[]) || []).map(i => i[classCol]))]
        .filter(Boolean)
        .sort((a, b) => String(a).localeCompare(String(b), undefined, {numeric: true}));

      classFilter.innerHTML = uniqueClasses.map(c => `<option value="${c}">Class ${c}</option>`).join('') || '<option value="">No Data</option>';

      // Fetch unique sections
      const { data: sectionsData } = await sb.from('student_database')
        .select(sectionCol)
        .not(sectionCol, 'is', null);
      
      const uniqueSections = [...new Set(((sectionsData as any[]) || []).map(i => i[sectionCol]))]
        .filter(Boolean)
        .sort();

      sectionFilter.innerHTML = uniqueSections.map(s => `<option value="${s}">${s}</option>`).join('') || '<option value="">No Data</option>';

    } catch (e) {
      console.error('Filter load error:', e);
      classFilter.innerHTML = '<option value="">Error</option>';
    }
  }

  // Initial load
  loadDynamicFilters();

  async function fetchRanks(iids: string[], sourceYear: string) {
    ranks = {};
    const tables: Record<string, string[]> = {
       '2025': ['exam_ann25', 'exam_test_2025'],
       '2024': ['exam_ann24', 'exam_test_2024']
    };
    const targetTables = tables[sourceYear] || [];
    for (const table of targetTables) {
      const { data } = await sb.from(table).select('iid, class_rank').in('iid', iids);
      if (data) {
        data.forEach(r => { if (r.class_rank) ranks[r.iid] = r.class_rank; });
      }
    }
  }

  loadBtn.onclick = async () => {
    const cls = classFilter.value;
    const sec = sectionFilter.value;
    if (!cls || !sec) {
      alert('Please select both class and section');
      return;
    }

    tableContainer.innerHTML = '<div class="loading-state pulse"><p>Fetching batch data and academic ranks...</p></div>';
    bulkFooter.style.display = 'none';
    searchWrap.style.display = 'none';

    const srcYear = sessionSource.value;

    const classCol = `class_${srcYear}`;
    const sectionCol = `section_${srcYear}`;
    const rollCol = `roll_${srcYear}`;

    const { data, error } = await sb.from('student_database')
      .select(`iid, student_name_en, ${classCol}, ${sectionCol}, ${rollCol}, session, group`)
      .eq(classCol, cls)
      .eq(sectionCol, sec)
      .order(rollCol);

    if (error) {
      tableContainer.innerHTML = `<div class="loading-state" style="color:red;">Error: ${error.message}</div>`;
      return;
    }

    students = ((data as any[]) || []).map(s => ({
      ...s,
      current_class: s[classCol],
      current_section: s[sectionCol],
      current_roll: s[rollCol]
    }));

    if (students.length === 0) {
      tableContainer.innerHTML = `<div class="loading-state">No students found for Class ${cls} (${sec}) in Session ${srcYear}.</div>`;
      return;
    }

    await fetchRanks(students.map(s => s.iid), srcYear);

    renderTable(students);
    searchWrap.style.display = 'flex';
    bulkFooter.style.display = 'flex';
    updateFooterStats();
  };

  function renderTable(data: any[]) {
    const cls = classFilter.value;
    const srcYear = sessionSource.value;
    const promotionMap: any = { '6': '7', '7': '8', '8': '9', '9': '10', '10': 'SSC' };
    const nextClass = promotionMap[cls] || cls;

    tableContainer.innerHTML = `
      <table>
        <thead>
          <tr>
            <th>Identity</th>
            <th>Name & Group</th>
            <th>Next Class</th>
            <th>Next Section</th>
            <th>New Roll</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          ${data.map(s => {
            const rank = ranks[s.iid];
            const suggestedRoll = rank || '';
            
            let suggestedSec = s.current_section;
            if (nextClass === '9' || nextClass === '10') {
               const grp = s.group?.toUpperCase() || '';
               if (grp.includes('SCIENCE')) suggestedSec = s.current_section + ' - SCIENCE';
               else if (grp.includes('HUMANITIES')) suggestedSec = s.current_section + ' - HUMANITIES';
               else if (grp.includes('BUSINESS')) suggestedSec = s.current_section + ' - BUSINESS';
            }

            return `
            <tr data-iid="${s.iid}">
              <td>
                <div style="font-weight:700; color:#0f172a;">${s.iid}</div>
                <div style="font-size:11px; color:#64748b;">Roll ${srcYear}: ${s.current_roll}</div>
              </td>
              <td>
                <div style="font-weight:600;">${s.student_name_en}</div>
                <div class="group-tag">${s.group || 'General'}</div>
                ${rank ? `<div class="rank-badge">Rank #${rank}</div>` : ''}
              </td>
              <td>
                <select class="p-input p-class" data-iid="${s.iid}">
                  <option value="6" ${nextClass === '6' ? 'selected' : ''}>Class 6</option>
                  <option value="7" ${nextClass === '7' ? 'selected' : ''}>Class 7</option>
                  <option value="8" ${nextClass === '8' ? 'selected' : ''}>Class 8</option>
                  <option value="9" ${nextClass === '9' ? 'selected' : ''}>Class 9</option>
                  <option value="10" ${nextClass === '10' ? 'selected' : ''}>Class 10</option>
                  <option value="SSC" ${nextClass === 'SSC' ? 'selected' : ''}>SSC (Old 10)</option>
                </select>
              </td>
              <td>
                <select class="p-input p-section" data-iid="${s.iid}">
                  <option value="MORNING" ${suggestedSec === 'MORNING' ? 'selected' : ''}>MORNING</option>
                  <option value="MORNING - SCIENCE" ${suggestedSec === 'MORNING - SCIENCE' ? 'selected' : ''}>MORNING - SCIENCE</option>
                  <option value="MORNING - HUMANITIES" ${suggestedSec === 'MORNING - HUMANITIES' ? 'selected' : ''}>MORNING - HUMANITIES</option>
                  <option value="MORNING - BUSINESS" ${suggestedSec === 'MORNING - BUSINESS' ? 'selected' : ''}>MORNING - BUSINESS</option>
                  <option value="DAY" ${suggestedSec === 'DAY' ? 'selected' : ''}>DAY</option>
                  <option value="DAY - SCIENCE" ${suggestedSec === 'DAY - SCIENCE' ? 'selected' : ''}>DAY - SCIENCE</option>
                  <option value="DAY - HUMANITIES" ${suggestedSec === 'DAY - HUMANITIES' ? 'selected' : ''}>DAY - HUMANITIES</option>
                  <option value="DAY - BUSINESS" ${suggestedSec === 'DAY - BUSINESS' ? 'selected' : ''}>DAY - BUSINESS</option>
                  <option value="SHAPLA" ${suggestedSec === 'SHAPLA' ? 'selected' : ''}>SHAPLA</option>
                  <option value="GOLAP" ${suggestedSec === 'GOLAP' ? 'selected' : ''}>GOLAP</option>
                </select>
              </td>
              <td>
                <input type="number" class="p-input p-roll" data-iid="${s.iid}" value="${suggestedRoll}" placeholder="Roll No">
              </td>
              <td>
                <button class="btn-promote" onclick="window.promoteSingle('${s.iid}')">Promote</button>
              </td>
            </tr>
          `}).join('')}
        </tbody>
      </table>
    `;
  }

  tableSearch.oninput = () => {
    const q = tableSearch.value.toLowerCase();
    const rows = Array.from(document.querySelectorAll('tbody tr'));
    let matches = 0;
    rows.forEach((row: any) => {
      const text = row.innerText.toLowerCase();
      const isMatch = text.includes(q);
      row.style.display = isMatch ? '' : 'none';
      if (isMatch) matches++;
    });
    matchCount.textContent = matches === students.length ? '' : `Showing ${matches} of ${students.length}`;
  };

  function updateFooterStats() {
    const filled = Array.from(document.querySelectorAll('.p-roll')).filter((i: any) => i.value).length;
    footerStats.textContent = `${filled} of ${students.length} students ready for promotion.`;
  }

  document.addEventListener('input', (e) => {
    if ((e.target as HTMLElement).classList.contains('p-roll')) updateFooterStats();
  });

  (window as any).promoteSingle = async (iid: string) => {
    const row = document.querySelector(`tr[data-iid="${iid}"]`) as HTMLElement;
    const cls = (row.querySelector('.p-class') as HTMLSelectElement).value;
    const sec = (row.querySelector('.p-section') as HTMLSelectElement).value;
    const roll = (row.querySelector('.p-roll') as HTMLInputElement).value;
    const btn = row.querySelector('.btn-promote') as HTMLButtonElement;
    const targetSession = sessionTarget.value;

    if (!roll) {
      alert('Please enter a new roll number');
      return;
    }

    btn.disabled = true;
    btn.innerHTML = 'Saving...';

    const updates: any = {
      session: targetSession
    };
    updates[`class_${targetSession}`] = cls;
    updates[`section_${targetSession}`] = sec;
    updates[`roll_${targetSession}`] = parseInt(roll);

    const { error } = await sb.from('student_database').update(updates).eq('iid', iid);

    if (error) {
      alert('Error: ' + error.message);
      btn.disabled = false;
      btn.innerHTML = 'Promote';
    } else {
      btn.innerHTML = '✓ Success';
      btn.style.background = '#059669';
      row.style.background = '#f0fdf4';
    }
  };

  bulkUpdateBtn.onclick = async () => {
    const rows = Array.from(document.querySelectorAll('tbody tr')).filter((r: any) => r.style.display !== 'none');
    const targetSession = sessionTarget.value;
    const updates = rows.map(row => {
      const iid = row.getAttribute('data-iid')!;
      const cls = (row.querySelector('.p-class') as HTMLSelectElement).value;
      const sec = (row.querySelector('.p-section') as HTMLSelectElement).value;
      const roll = (row.querySelector('.p-roll') as HTMLInputElement).value;
      if (!roll) return null;
      const up: any = { iid, session: targetSession };
      up[`class_${targetSession}`] = cls;
      up[`section_${targetSession}`] = sec;
      up[`roll_${targetSession}`] = parseInt(roll);
      return up;
    }).filter(u => u !== null);

    if (updates.length === 0) {
      alert('No students with roll numbers selected for promotion.');
      return;
    }

    if (!confirm(`Confirm promotion for ${updates.length} students to Session ${targetSession}?`)) return;

    bulkUpdateBtn.disabled = true;
    bulkUpdateBtn.innerHTML = `<span>Processing ${updates.length}...</span>`;

    let successCount = 0;
    for (const up of updates) {
      const { iid, ...payload } = up!;
      const { error } = await sb.from('student_database').update(payload).eq('iid', iid);
      if (!error) {
        successCount++;
        const row = document.querySelector(`tr[data-iid="${iid}"]`)!;
        const btn = row.querySelector('.btn-promote') as HTMLButtonElement;
        btn.innerHTML = '✓ Success';
        btn.disabled = true;
        btn.style.background = '#059669';
        (row as HTMLElement).style.background = '#f0fdf4';
      }
    }

    alert(`Promotion Complete! ${successCount} students updated.`);
    bulkUpdateBtn.disabled = false;
    bulkUpdateBtn.innerHTML = '<span>Promote Selected Students</span>';
  };
}
